if (!customElements.get('reviews-logo-slider')) {
  customElements.define(
    'reviews-logo-slider',
    class ReviewsLogoSlider extends HTMLElement {
      connectedCallback() {
        this.triggers = [...this.querySelectorAll('[data-review-trigger]')];
        this.quotes = [...this.querySelectorAll('[data-review-quote]')];
        this.track = this.querySelector('[data-review-track]');
        this.slides = [...this.querySelectorAll('[data-review-slide]')];
        this.status = this.querySelector('[data-review-status]');

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.selectReview(trigger.dataset.reviewTrigger));
        });

        this.querySelector('[data-review-previous]')?.addEventListener('click', () => this.move(-1));
        this.querySelector('[data-review-next]')?.addEventListener('click', () => this.move(1));
        this.track?.addEventListener('scroll', () => this.updateStatus(), { passive: true });

        this.updateStatus();
      }

      selectReview(id) {
        this.triggers.forEach((trigger) => {
          const isActive = trigger.dataset.reviewTrigger === id;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        this.quotes.forEach((quote) => quote.classList.toggle('is-active', quote.dataset.reviewQuote === id));
      }

      currentIndex() {
        if (!this.track?.clientWidth) return 0;
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      move(direction) {
        if (!this.track || this.slides.length < 2) return;
        const nextIndex = (this.currentIndex() + direction + this.slides.length) % this.slides.length;
        this.slides[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      updateStatus() {
        if (!this.status || !this.slides.length) return;
        this.status.textContent = `${this.currentIndex() + 1} / ${this.slides.length}`;
      }
    }
  );
}
